import * as React from "react";
import i18n from "i18n";
import { useState, useEffect } from "react";

import {
  CircularProgress,
  Input,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import {
  Done as DoneIcon,
  Create as CreateIcon,
  Close,
} from "@material-ui/icons";

import { CompositionStore } from "modules/composition/CompositionStore";
import { formatNumber } from "utils/MathUtils";

const ResourceRow = (props) => {
  const {
    classes,
    item,
    rateTask,
    btnEdit,
    key,
    hasAlternativeCode,
    _reloadComponent,
    _setLoaded,
  } = props;
  // const [load, setLoad] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editTextTotal, setEditTextTotal] = useState(false);
  const [editBtnEdit, seteEditBtnEdit] = useState(btnEdit);
  const estilo = CompositionStore.benchComposition.data.publicLibrary
    ? { width: "910px", flex: "15 0 9%" }
    : { width: "770px", flex: "15 0 9%" };

  let textTotal = item.data.totalCost
    ? formatNumber(item.data.totalCost)
    : formatNumber("0.0");

  const [stateTextTotalDef, setStateTextTotalDef] = useState(textTotal);
  const [stateTextTotal, setStateTextTotal] = useState(textTotal);

  useEffect(() => {
    setStateTextTotal(textTotal);
    setEdit(false);
  }, [item]);

  useEffect(() => {
    seteEditBtnEdit(btnEdit);
  }, [btnEdit]);

  const editClickHandler = () => {
    props.alterarBtnEdit();
    setEdit(!edit);
  };

  const cancelEdit = () => {
    setStateTextTotal(stateTextTotalDef);
    if (editTextTotal == true) setEditTextTotal(false);
    setEdit(!edit);
    props.alterarBtnEdit();
  };

  const saveElementes = async () => {
    setEdit(!edit);
    _setLoaded(false);
    if (editTextTotal !== false) {
      await CompositionStore.setResourceById(
        item.data.file.id,
        item.id,
        stateTextTotal
      );
      setStateTextTotalDef(stateTextTotal);
      _reloadComponent(); // Após o processamento do serviço a função é chamada para fazer o componente pai renderizar novamente
    }
    setEditTextTotal(false);
    props.alterarBtnEdit();
  };

  // Função para salvar os dados ao precionar a tecla enter no teclado
  const keyPress = (e) => {
    if (e.charCode === 13) {
      saveElementes();
    }
  };

  const editInput = (value, type) => {
    if (type === "totalCost") {
      value = value.replace(",", ".");
      let nume = formatNumber(value);
      setStateTextTotal(nume);
      setEditTextTotal(true);
    }
  };

  return (
    <>
      <TableCell
        className={classes.taskCellFlex}
        style={{ width: "110px", flex: "1 1 5%" }}
      >
        {item.data.code}
      </TableCell>
      {hasAlternativeCode && (
        <TableCell
          className={classes.taskCellFlex}
          style={{ width: "110px", flex: "1 1 5%" }}
        >
          {item.data.alternativeCodeItem
            ? item.data.alternativeCodeItem
            : item.data.alternativeCodeComposition}
        </TableCell>
      )}
      <TableCell className={classes.taskCellFlex} style={estilo}>
        {item.data.description.charAt(0).toUpperCase() +
          item.data.description.slice(1)}
      </TableCell>
      <TableCell
        className={classes.taskCellFlex}
        numeric
        style={{ width: "100px", flex: "1.5 1 0%" }}
      >
        {item.data.unity}
      </TableCell>
      <TableCell
        className={classes.taskCellFlex}
        numeric
        style={{ width: "135px", flex: "2 1 0%" }}
      >
        {!edit ? (
          stateTextTotal
        ) : (
          <Input
            classes={{ input: classes.inputCell }}
            defaultValue={stateTextTotal}
            placeholder={i18n.rateLibraries.header.totalCost}
            onChange={(e) => editInput(e.target.value, "totalCost")}
            onKeyPress={(e) => keyPress(e)}
          />
        )}
      </TableCell>
      {!CompositionStore.benchComposition.data.publicLibrary && ( // Se o banco de composição for uma biblioteca publica ele exibe a colina de edição
        <TableCell
          className={classes.taskCellFlex}
          style={{ textAlign: "right", width: "130px", flex: "2 1 0%" }}
        >
          {!edit ? (
            <IconButton
              className={classes.buttons}
              aria-label="Edite"
              onClick={() => editClickHandler()}
              disabled={editBtnEdit}
            >
              <Tooltip title={i18n.editto}>
                <CreateIcon className={classes.iconMenu} />
              </Tooltip>
            </IconButton>
          ) : (
            <>
              <IconButton
                className={classes.buttons}
                aria-label="Save"
                onClick={() => saveElementes()}
              >
                <Tooltip title={i18n.save}>
                  <DoneIcon
                    className={classes.iconMenu}
                    style={{ color: "#0E8755" }}
                  />
                </Tooltip>
              </IconButton>
              <IconButton
                className={classes.buttons}
                aria-label="Cancel"
                onClick={() => cancelEdit()}
              >
                <Tooltip title={i18n.cancel}>
                  <Close
                    className={classes.iconMenu}
                    style={{ color: "#D73912" }}
                  />
                </Tooltip>
              </IconButton>
            </>
          )}
        </TableCell>
      )}
    </>
  );
};

export default ResourceRow;



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/ResourceRow.tsx